import CryptoJS from 'crypto-js';

const secretKey = process.env.QR_SECRET_KEY || 'fallback-key-for-dev'; // In production, store this securely

export function encryptObject(obj: Record<string, any>): string {
  const jsonString = JSON.stringify(obj);
  return CryptoJS.AES.encrypt(jsonString, secretKey).toString();
}

export function decryptToObject(cipherText: string): Record<string, any> {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString);
}
